import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "page",
  class: "order-page",
  "dark-class": "order-page-dark"
}
const _hoisted_2 = { class: "tool-bar-box" }
const _hoisted_3 = { class: "item-bar filter-box" }
const _hoisted_4 = {
  class: "item-box",
  id: "order_entity"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "所属订单", -1)
const _hoisted_6 = { class: "value" }
const _hoisted_7 = {
  class: "item-box",
  id: "order_entity"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "日期范围", -1)
const _hoisted_9 = {
  key: 0,
  class: "p"
}
const _hoisted_10 = {
  key: 1,
  class: "p"
}
const _hoisted_11 = { class: "item-bar mode-base" }
const _hoisted_12 = { class: "mode-box" }
const _hoisted_13 = { class: "item-bar operating-box" }
const _hoisted_14 = { class: "search-box" }
const _hoisted_15 = { class: "icon-base" }
const _hoisted_16 = {
  key: 0,
  class: "icon-base close"
}
const _hoisted_17 = {
  class: "order-box",
  "dark-class": "order-box-dark"
}
const _hoisted_18 = { class: "status" }
const _hoisted_19 = { class: "operating-btn" }
const _hoisted_20 = { class: "floor-box contact-box" }
const _hoisted_21 = { class: "item-box" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "订单编号:", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "item-box" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "下单时间:", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = {
  key: 0,
  class: "item-box"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "联系人:", -1)
const _hoisted_29 = { class: "value" }
const _hoisted_30 = {
  key: 1,
  class: "item-box"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "地址:", -1)
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "floor-box goods-box" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "info-box" }
const _hoisted_36 = { class: "name" }
const _hoisted_37 = { class: "spec" }
const _hoisted_38 = { class: "quantity" }
const _hoisted_39 = { class: "floor-box data-box" }
const _hoisted_40 = { class: "item-box" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "订单金额", -1)
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "item-box" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "运费", -1)
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "item-box" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "分销", -1)
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "floor-box operate-box" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_elem_options = _resolveComponent("elem-options")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_comp_menu = _resolveComponent("comp-menu")!
  const _component_comp_empty = _resolveComponent("comp-empty")!
  const _component_comp_model = _resolveComponent("comp-model")!
  const _component_comp_form = _resolveComponent("comp-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_ctx.order_info_ac ? _ctx.order_info_ac.title : "请选择"), 1),
            _createVNode(_component_elem_icon, {
              class: "icon",
              name: "select"
            })
          ]),
          _createVNode(_component_elem_options, {
            all: false,
            el: "#order_entity",
            data: _ctx.order_infos,
            onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.order_info_ac = $event.value))
          }, null, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_DatePicker, {
            open: _ctx.date_open,
            "model-value": _ctx.date_range,
            confirm: "",
            clearable: "",
            type: "daterange",
            "split-panels": "",
            onOnClear: _cache[2] || (_cache[2] = ($event: any) => (_ctx.date_open = false)),
            onOnClickoutside: _cache[3] || (_cache[3] = ($event: any) => (_ctx.date_open = false)),
            onOnOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.date_open = false)),
            onOnChange: _ctx.onChangeDate
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "value",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.date_open = true))
              }, [
                (_ctx.date_range)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.date_range.join(" - ")), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_10, "所有")),
                _createVNode(_component_elem_icon, {
                  class: "icon",
                  name: "select"
                })
              ])
            ]),
            _: 1
          }, 8, ["open", "model-value", "onOnChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(["item-box", { activity: _ctx.mode === 'TODOS' }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeMode('TODOS')))
          }, "待处理 (" + _toDisplayString(_ctx.todo_q) + ")", 3),
          _createElementVNode("div", {
            class: _normalizeClass(["item-box", { activity: _ctx.mode === 'ALL' }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeMode('ALL')))
          }, "全部订单", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_elem_icon, {
              class: "icon-box",
              name: "search"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            placeholder: "输入订单编号",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.search) = $event)),
            onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitSearch && _ctx.onSubmitSearch(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.search]
          ]),
          (_ctx.search)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_elem_icon, {
                  class: "icon-box",
                  name: "close",
                  onClick: _ctx.onClearSearch
                }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderList, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item-box",
          key: idx
        }, [
          _createElementVNode("div", {
            class: "head-box",
            style: _normalizeStyle({ backgroundColor: _ctx.getOrderStatusColor(item)})
          }, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.getOrderStatus(item)), 1),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_elem_icon, { name: "operating" }),
              _createVNode(_component_comp_menu, {
                absolute: true,
                position: "follow",
                maxWidth: "200px",
                value: _ctx.getMenu(item),
                onSelect: ($event: any) => (_ctx.onSelectMenu(item, $event))
              }, null, 8, ["value", "onSelect"])
            ])
          ], 4),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("p", _hoisted_23, _toDisplayString(item.orderNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("p", _hoisted_26, _toDisplayString(item.createdDate), 1)
            ]),
            (item.address)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("p", _hoisted_29, _toDisplayString([item.address.name, item.address.phone].join(" - ")), 1)
                ]))
              : _createCommentVNode("", true),
            (item.address)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("p", _hoisted_32, _toDisplayString([item.address.province, item.address.city, item.address.district, item.address.address].join(" - ")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.goodsItems, (goods, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx,
                title: goods.title
              }, [
                _createElementVNode("div", {
                  class: "img",
                  style: _normalizeStyle({ 'background-image': 'url(' + goods.cover.url + '?x-oss-process=image/resize,m_fill,h_300,w_300,limit_0' + ')' })
                }, null, 4),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, _toDisplayString(goods.title), 1),
                  _createElementVNode("div", _hoisted_37, _toDisplayString(goods.specification?.map(v => v.title).join(', ')), 1),
                  _createElementVNode("div", _hoisted_38, "x" + _toDisplayString(goods.quantity), 1)
                ])
              ], 8, _hoisted_34))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("p", _hoisted_42, "￥" + _toDisplayString(_ctx.centsToYuan(item.price)), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("p", _hoisted_45, "￥" + _toDisplayString(_ctx.centsToYuan(item.postagePrice)), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("p", _hoisted_48, _toDisplayString(item.distribution ? item.distribution.name : "-"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            (item.transportStatus === 'WAITING_ACCEPT')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "item g",
                  onClick: ($event: any) => (_ctx.onAccepted(item))
                }, "接单", 8, _hoisted_50))
              : (item.transportStatus === 'WAITING_SHIPMENTS' && item.address)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "item b",
                    onClick: ($event: any) => (_ctx.onShipments(item))
                  }, "发货", 8, _hoisted_51))
                : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      (_ctx.orderList && _ctx.orderList.length == 0)
        ? (_openBlock(), _createBlock(_component_comp_empty, {
            key: 0,
            botton: false,
            title: "当前订单为空",
            prompt: "收到新订单时将为你第一时间显示"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_comp_model, {
      ref: "comp_model",
      title: _ctx.model_title,
      scroll: false
    }, {
      default: _withCtx(() => [
        (_ctx.model_url)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              ref: "iframe",
              src: _ctx.model_url,
              frameborder: "0",
              onLoad: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onLoadIframe && _ctx.onLoadIframe(...args))),
              width: "100%",
              height: "100%"
            }, null, 40, _hoisted_52))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_comp_form, {
      ref: "comp_form",
      onOnSubmit: _ctx.onSubmitForm
    }, null, 8, ["onOnSubmit"])
  ], 512))
}